import { apiSlice } from './apiSlice';

interface SystemSetting {
  id: number;
  mappedTo: string;
  text: string;
  description: string;
  type: string;
  context: string;
  default: boolean;
  isDefinedOptions: boolean;
  parentId: number | null;
  options: string[];
  selection: boolean | null;
}

export interface SystemSettingsResponse {
  registration: SystemSetting;
  deposit: SystemSetting;
  withdrawal: SystemSetting;
  masteranalytics?: SystemSetting;
  LayMarket?: SystemSetting;
}

export const systemApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSystemSettings: builder.query<SystemSettingsResponse, void>({
      query: () => ({
        url: '/system',
        method: 'GET',
        params: { t: Date.now() },
      }),
      providesTags: ['SystemSettings'],
    }),
  }),
});

export const { useGetSystemSettingsQuery } = systemApi;
